// services/crypto.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CryptoService {

  private cryptoKey: CryptoKey | null = null;

  async init(): Promise<void> {
    const rawKey = Uint8Array.from(
      atob(environment.aesKey), c => c.charCodeAt(0)
    );
    this.cryptoKey = await crypto.subtle.importKey(
      'raw', rawKey, { name: 'AES-GCM' }, false, ['decrypt']
    );
  }

  async decrypt(base64Payload: string): Promise<string> {
    if (!this.cryptoKey) await this.init();

    const payload = Uint8Array.from(atob(base64Payload), c => c.charCodeAt(0));
    const iv = payload.slice(0, 12);
    const tag = payload.slice(12, 28);
    const ciphertext = payload.slice(28);

    const ciphertextWithTag = new Uint8Array([...ciphertext, ...tag]);

    const decrypted = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv, tagLength: 128 },
      this.cryptoKey!,
      ciphertextWithTag
    );

    return new TextDecoder().decode(decrypted);
  }
}
